import React from 'react'
import SvgWrapper from '../SvgWrapper'
import type { IllustrationProps } from './types'

const YogaWomanIllustration: React.FC<IllustrationProps> = ({ width = 62, height = 161 }) => (
  <SvgWrapper height={height} width={width} viewBox="0 0 62 160.78" fill="none">
    <path
      d="M39.43 17.906s-4.486-1.602-7.37 4.807c-2.884 6.41-7.371 13.46-7.371 13.46l2.564.64s.64-4.486 2.243-5.127l-.64 5.769s16.488 6.73 25.14-.641l.962-2.296v2.296l2.244-1.014s-.962-1.923-3.846-4.487a8.922 8.922 0 0 1-2.929-5.812 8.331 8.331 0 0 0-1.918-4.538c-1.917-2.221-3.79-5.603-9.078-3.057Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path
      d="m34.698 43.036-4.647-5.809-3.485-11.908 13.36-14.231S42.831.05 40.216.632c-2.613.581-3.194 8.713-3.194 8.713l-16.845 13.07s1.742 18.298 6.68 24.687l3.775 11.908 4.066-15.974Z"
      fill="#D7B7A8"
    />
    <path
      d="m47.478 43.036 4.647-5.809L55.61 25.32 42.25 11.088S39.346.05 41.96.632c2.614.581 3.194 8.713 3.194 8.713L62 22.415s-1.743 18.298-6.68 24.687L51.544 59.01l-4.066-15.974Z"
      fill="#D7B7A8"
    />
    <path d="M41.307 37.41a6.966 6.966 0 1 0 0-13.933 6.966 6.966 0 0 0 0 13.932Z" fill="#D7B7A8" />
    <path
      d="M37.603 34.613s.29 6.1-1.452 8.133c-1.743 2.033-3.486 12.489 4.937 12.78 8.423.29 7.552-8.714 7.552-8.714l-1.743-4.937s-2.615-3.776-1.743-7.261h-7.551ZM29.761 102.285l6.244 1.888s5.083-3.049 5.083-.145-1.742 6.68-1.162 9.294c.581 2.614 1.743 9.004 0 9.004-1.742 0-5.227-11.328-5.227-11.328l-5.81-3.194.872-5.519ZM37.603 142.947l-2.324 9.003s-2.033 2.615 0 3.776c.954.545 1.652 1.666 2.125 2.702a4.97 4.97 0 0 0 4.877 2.951c.992-.083 1.827-.475 2.03-1.493a2.339 2.339 0 0 0-.45-1.83c-2.142-2.896-2.628-4.799-2.628-4.799l.871-10.165-4.501-.145Z"
      fill="#D7B7A8"
    />
    <path
      d="M31.979 31.889s2.886-5.693 5.13-6.334c2.243-.641 3.02 0 3.02 0s4.99 2.564 8.514 2.884c3.526.32.32-5.524.32-5.524l-6.409-1.602-6.089.64-4.807 3.205.32 6.73Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path
      d="m27.147 80.212-1.162 2.323S-2.187 91.54.136 99.962c2.324 8.422 15.393 6.099 15.393 6.099l14.522 2.615 1.453-6.39-10.166-2.615 17.426-6.39.581 29.625-2.323 21.202 5.809.581s6.39-19.459 5.517-27.591c0 0 10.748-33.11 4.647-38.048-6.1-4.938-25.848 1.163-25.848 1.163Z"
      fill="#2E35A8"
    />
    <path
      d="m41.428 46.816-4.532-5.477-3.07 1.407-3.194 10.166s-2.615 4.937.58 10.165c0 0 .582 3.485-.29 4.357-.87.87-1.161 6.39-1.161 6.39l-3.776 7.26s21.492 3.776 27.882-1.452c0 0-3.353-12.361-1.32-16.137 2.033-3.776 2.324-9.564 0-12.178-2.323-2.614-4.78-9.442-4.78-9.442l-1.406-.9-4.933 5.84Z"
      fill="#A5A9DA"
    />
  </SvgWrapper>
)

export default YogaWomanIllustration
